import React, { useEffect, useRef } from 'react';

/** @jsx jsx */
import { css, jsx } from '@emotion/core';

import { Knobs } from '../Docs/DocTypes';
import { KnobValues, parseCodeWithKnobs } from './CodePreview/KnobsUtils';
import { clearChildNodes, injectCode, getJSForEvents, removeEvents } from './RunningCodeUtils';
import { ErrorBoundary } from './ErrorBoundary';
import { RunningCodeEventsRaised } from './RunningCodeEventsRaised';
import PhoneBorderImage from './phoneborder.png';

const codeClassName = 'code-preview-html-code';

type RunningHtmlCodeProps = {
  html?: string;
  events?: string[];
  js?: string;
  knobs?: Knobs;
  knobValues?: KnobValues;
  backgroundVisible?: boolean;
  isV3?: boolean;
  mobileView?: boolean;
};
export const RunningHtmlCode = (props: RunningHtmlCodeProps) => {
  const htmlCodeElement = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const htmlCodeElementRef = htmlCodeElement.current;
    if (htmlCodeElementRef && props.html) {
      clearChildNodes(htmlCodeElementRef);

      injectCode(
        htmlCodeElementRef,
        parseCodeWithKnobs(props.html, props.knobs, props.knobValues, true),
        `
      ${props.js}
      ${getJSForEvents(props.events, `.${codeClassName}`)}
              `,
      );
    }
    return () => {
      if (htmlCodeElementRef && props.html) {
        removeEvents(props.events, `.${codeClassName}`);
        clearChildNodes(htmlCodeElementRef);
      }
    };
  }, [props.html, props.events, props.js, props.knobs, props.knobValues]);

  // const makeStyles = (isV3?: boolean, isMobileView?: boolean) => {
  //   return css`
  //     ${isV3 ? `font-family: 'Brush Script MT', 'Brush Script Std', cursive; ` : ''}
  //     ${isMobileView
  //       ? ``
  //       : ''}
  //   `;
  // };

  return (
    <ErrorBoundary>
      <div
        css={css`
          background-image: ${props.backgroundVisible
            ? `url('code-preview-background.png')`
            : undefined};
        `}
      >
        {props.mobileView && (
          <div
            className={`${codeClassName} code-preview-html-code__mobile`}
            css={
              props.isV3 &&
              css`
                font-family: 'Brush Script MT', 'Brush Script Std', cursive;
              `
            }
            style={{
              width: '431px',
              height: '877px',
              background: `url('${PhoneBorderImage}') center center no-repeat`,
              backgroundSize: '431px 877px',
              boxSizing: 'border-box',
              padding: '105px 28px 105px 28px',
            }}
          >
            <div
              className={`code-preview-html-code__mobile--inner`}
              ref={htmlCodeElement}
              style={{
                height: '667px',
                width: '375px',
                transform: 'translate(0px, 0px)',
                overflow: 'hidden',
              }}
            ></div>
          </div>
        )}
        {!props.mobileView && (
          <div
            ref={htmlCodeElement}
            className={`${codeClassName}`}
            css={
              props.isV3 &&
              css`
                font-family: 'Brush Script MT', 'Brush Script Std', cursive;
              `
            }
          ></div>
        )}

        <RunningCodeEventsRaised htmlEvents={props.events} />
      </div>
    </ErrorBoundary>
  );
};
